import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
import canUseDom from "../utils/canUseDom";
import plutusLogo from "../../images/project-logos/prestigious-logo-1.png";

function ProjectLogos({ conClass = "section-pad border-bottom" }) {
  const data = useAllProjectLogos();
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  // Add error handling for missing images
  const renderImage = (imageData, alt, fallbackAlt = "Project Logo") => {
    if (!imageData || !imageData.childImageSharp || !imageData.childImageSharp.fluid) {
      return <div className="mb-3" style={{ width: '100%', height: '100px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Image not available</div>;
    }
    
    return (
      <Img
        className="mb-3"
        fluid={imageData.childImageSharp.fluid}
        alt={alt || fallbackAlt}
        loading="lazy"
        fadeIn={false}
      />
    );
  };

  // Show loading state on server-side to prevent hydration mismatch
  if (!isClient) {
    return (
      <section className={conClass}>
        <div className="container">
          <h3 className="section-title text-center">
            Prestigious Ongoing Projects
          </h3>
          <div className="row align-items-center justify-content-center">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="col-6 col-md-2 wow zoomIn justify-content-center">
                <div className="mb-3" style={{ width: '100%', height: '100px', backgroundColor: '#f0f0f0' }}></div>
              </div>
            ))}
          </div>
        </div>
        <div className="container" style={{ marginTop: "50px" }}>
          <h3 className="section-title text-center">
            Prestigious Completed Projects
          </h3>
          <div className="row align-items-center justify-content-center">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="col-6 col-md-2 wow zoomIn">
                <div className="mb-3" style={{ width: '100%', height: '100px', backgroundColor: '#f0f0f0' }}></div>
              </div>
            ))}
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-6 col-md-2 wow zoomIn">
              <div className="mb-3" style={{ width: '100%', height: '100px', backgroundColor: '#f0f0f0' }}></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={conClass}>
      <div className="container">
        <h3 className="section-title text-center">
          Prestigious Ongoing Projects
        </h3>
        <div className="row align-items-center justify-content-center">
          
          {/* <div className="col-6 col-md-2 wow zoomIn justify-content-center">
            <Link to="/the-edge-gopalapuram-chennai/">
              {renderImage(data.image16, "The Edge")}
            </Link>
          </div> */}
        <div className="col-6 col-md-2 wow zoomIn justify-content-center">
            <Link to="/srinivasa-west-mambalam-chennai/">
              {renderImage(data.image15, "Srinivasa")}
            </Link>
          </div>
        <div className="col-6 col-md-2 wow zoomIn justify-content-center">
            <Link to="/enchanted-luxury-apartments-in-thoraipakkam-chennai/">
              {renderImage(data.image14, "Enchanted")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn justify-content-center">
            <Link to="/crown-residence-luxury-apartments-koyambedu-chennai/">
              {renderImage(data.image8, "Crown Residence")}
            </Link>
          </div>
          {/* <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/the-peak-high-rise-apartments-in-ashok-nagar/">
              {renderImage(data.image9, "The Peak")}
            </Link>
          </div> */}
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/the-pinnacle-ra-puram-chennai/">
              {renderImage(data.image13, "The Pinnacle")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/royal-damera-gardens-poes-garden/">
              {renderImage(data.image10, "Royal Damera Gardens")}
            </Link>
          </div>
          {/* <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/emperors-pavilion/">
              {renderImage(data.image4, "Emperors Pavilion")}
            </Link>
          </div> */}
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/promenade-commercial-guindy-chennai/">
              {renderImage(data.image11, "Promenade")}
            </Link>
          </div>
        </div>
      </div>

      <div className="container" style={{ marginTop: "50px" }}>
        <h3 className="section-title text-center">
          Prestigious Completed Projects
        </h3>
        <div className="row align-items-center justify-content-center">

          
          <div className="col-6 col-md-2 wow zoomIn justify-content-center">
            <Link to="/cloud-graze-luxury-apartments-kk-nagar/">
              {renderImage(data.image7, "Cloud Graze")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/the-plutus-residence-chennai/">
              <img
                className="mb-3"
                src={plutusLogo}
                alt="The Plutus Residence"
              />
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/bonaventura/">
              {renderImage(data.image2, "Bonaventura")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/le-grand-trianon-poes-garden-Teynampet-chennai/">
              {renderImage(data.image3, "Le Grand Trianon")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/sadhr-gardens/">
              {renderImage(data.image5, "Sadhr Gardens")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/57-poes/">
              {renderImage(data.image6, "57 Poes")}
            </Link>
          </div>
        </div>
        <div className="row align-items-center justify-content-center">
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/willow-square-commercial-guindy-chennai/">
              {renderImage(data.image12, "Willow Square")}
            </Link>
          </div>
          <div className="col-6 col-md-2 wow zoomIn">
            <Link to="/the-peak-high-rise-apartments-in-ashok-nagar/">
              {renderImage(data.image9, "The Peak")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export const useAllProjectLogos = () =>
  useStaticQuery(graphql`
    query {
      image1: file(
        relativePath: { eq: "project-logos/prestigious-logo-1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image2: file(
        relativePath: { eq: "project-logos/prestigious-logo-2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image3: file(
        relativePath: { eq: "project-logos/prestigious-logo-3.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image4: file(
        relativePath: { eq: "project-logos/prestigious-logo-4.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image5: file(
        relativePath: { eq: "project-logos/prestigious-logo-5.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image6: file(
        relativePath: { eq: "project-logos/prestigious-logo-6.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image7: file(
        relativePath: { eq: "project-logos/prestigious-logo-7.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image8: file(
        relativePath: { eq: "project-logos/prestigious-logo-8.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image9: file(
        relativePath: { eq: "project-logos/prestigious-logo-9.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image10: file(
        relativePath: { eq: "project-logos/prestigious-logo-10.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image11: file(
        relativePath: { eq: "project-logos/prestigious-logo-11.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image12: file(
        relativePath: { eq: "project-logos/prestigious-logo-12.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image13: file(
        relativePath: { eq: "project-logos/prestigious-logo-13.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image14: file(
        relativePath: { eq: "project-logos/prestigious-logo-14.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image15: file(
        relativePath: { eq: "project-logos/prestigious-logo-15.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image16: file(
        relativePath: { eq: "project-logos/prestigious-logo-16.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 340) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

export default ProjectLogos;
